import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import * as Colors from 'material-ui/styles/colors';
import CloseIcon from 'material-ui/svg-icons/navigation/close';


export default class PoppingTextElement extends Component {

  state = {
    focused: false,
  };

  handleChange = (event, value) => {
    const {onChangeValue} = this.props;
    const updatedValue = value ? value : '';
    onChangeValue(updatedValue);
  };

  render() {
    const {value, height, width, style} = this.props;
    const {focused} = this.state;
    return (
      <Paper
        style={{
          height: height,
          width: width,
          marginLeft: 10,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: focused ? Colors.white : Colors.grey200,
        }}
        zDepth = {focused ? 1 : 0}
        onClick = {() => this.categoryTextField.focus()}
      >
        <TextField
          id="CategoryNumberTextField"
          ref={(ref) => this.categoryTextField = ref}
          fullWidth
          style={{
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            marginLeft: 10,
            ...style
          }}
          underlineShow={false}
          value={value}
          onChange={this.handleChange}
          onFocus={() => this.setState({focused: true})}
          onBlur={() => this.setState({focused: false})}
        />
        {value !== '' &&
        <IconButton onClick={this.handleChange}>
          <CloseIcon/>
        </IconButton>
        }
      </Paper>
    );
  }
}

PoppingTextElement.propTypes = {
  initialValue: PropTypes.string,
  controlledValue: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  style: PropTypes.object,
  onChangeValue: PropTypes.func.isRequired,
};

PoppingTextElement.defaultProps = {
  initialValue: '',
  height: 48,
  width: 150,
};